import React, { useState } from 'react';
import { useFormik } from 'formik';
import Select from 'react-select';

import Input from '../components/Input';
import Logo from '../components/Logo';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import { postRetailer } from '../api/agape-service';
import { Retailer } from '../api/agape-model';
import ThankYou from '../components/ThankYou';

const uniqueBrandOptions = [
  { value: '1-10', label: '1-10' },
  { value: '11-25', label: '11-25' },
  { value: '26-50', label: '26-50' },
  { value: '51-100', label: '51-100' },
  { value: '101-250', label: '101-250' },
  { value: '251-500', label: '251-500' },
  { value: '501-1000', label: '501-1000' },
  { value: 'More than 1000', label: 'More than 1000' },
];

const SignUpAsARetailer: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      retailName: '',
      website: '',
      name: '',
      email: '',
      numberOfBrands: '',
      instagramHandle: '',
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.retailName) {
        errors.retailName = 'Retail name is required';
      }

      if (!values.website) {
        errors.website = 'Website URL is required';
      }

      if (!values.name) {
        errors.name = 'Name is required';
      }

      if (!values.email) {
        errors.email = 'Email Address is required';
      }

      if (!values.numberOfBrands) {
        errors.numberOfRetailers = 'Number of brands is required';
      }

      if (!values.instagramHandle) {
        errors.instagramHandle = 'Instagram Handle is required';
      }

      return errors;
    },
    onSubmit: async (values) => {
      try {
        const retailer: Retailer = {
          retailerName: values.retailName,
          website: values.website,
          name: values.name,
          email: values.email,
          numberOfUniqueBrands: values.numberOfBrands,
          instagramHandle: values.instagramHandle,
        };
        setIsSubmitting(true);
        await postRetailer(retailer);
        setIsSubmitting(false);
        setShowModal(true);
      } catch (err) {
        setIsSubmitting(false);
        alert('Something went wrong');
      }
    },
  });

  const handleModalClose = () => {
    formik.resetForm();
    setShowModal(false);
  };

  const getSelectValue = (value: any) => {
    const option = uniqueBrandOptions.find((item) => item.value === value);
    return option ? option : null;
  };

  const handleSelectValueChange = (value: any) => {
    formik.setFieldValue('numberOfBrands', value.value);
  };

  return (
    <>
      <section className="bg-black flex justify-center items-center">
        <div className="form-container flex flex-col items-center pt-10">
          <Logo logoClass="text-mandys-pink" />
          <span className="block text-white text-center text-sm leading-4 py-2 mb-2 md:mb-4">
            Coming Soon!
          </span>
          <p className="font-lato font-bold text-center text-pampas form__description">
            Sign up for more information on how to join the movement.
          </p>

          <form onSubmit={formik.handleSubmit} className="app-form">
            <Input
              type="text"
              placeholder="Retail name"
              className="mb-6 lg:mb-8"
              required
              error={formik.touched.retailName && formik.errors.retailName ? true : false}
              {...formik.getFieldProps('retailName')}
            />

            <Input
              type="text"
              placeholder="Website url"
              className="mb-6 lg:mb-8"
              required
              error={formik.touched.website && formik.errors.website ? true : false}
              {...formik.getFieldProps('website')}
            />

            <Input
              type="text"
              placeholder="Your name"
              className="mb-6 lg:mb-8"
              required
              error={formik.touched.name && formik.errors.name ? true : false}
              {...formik.getFieldProps('name')}
            />

            <Input
              type="email"
              placeholder="Email address"
              className="mb-6 lg:mb-8"
              required
              error={formik.touched.email && formik.errors.email ? true : false}
              {...formik.getFieldProps('email')}
            />

            <Select
              placeholder="Number of unique brands you stock"
              name="numberOfRetailers"
              onChange={handleSelectValueChange}
              isSearchable={false}
              isClearable={false}
              options={uniqueBrandOptions}
              className="mb-6 lg:mb-8 app-select"
              classNamePrefix="app-select"
              value={getSelectValue(formik.values.numberOfBrands)}
            />

            <Input
              type="text"
              placeholder="Instagram handle"
              className="mb-6 lg:mb-8"
              required
              error={formik.touched.instagramHandle && formik.errors.instagramHandle ? true : false}
              {...formik.getFieldProps('instagramHandle')}
            />

            <Button
              title="Submit"
              type="submit"
              buttonClass="w-full mb-6 lg:mb-8 py-2"
              disabled={!formik.isValid || isSubmitting}
              loading={isSubmitting}
            />
          </form>

          <Link
            to="/brands/refer"
            className="text-mandys-pink font-medium text-base leading-4 mb-8"
          >
            Refer A Brand
          </Link>
          <Link to="/" className="text-mandys-pink font-medium text-base leading-4 mb-8">
            Back To Home
          </Link>
        </div>
      </section>
      <ThankYou show={showModal} showFooterLink={false} onCloseClick={handleModalClose} />
    </>
  );
};

export default SignUpAsARetailer;
